module.exports = __webpack_public_path__ + "img/2ff6f4d9c7750b46bc49915af54c8fca.7845eab9.png";